import styled, { css } from 'styled-components'

export const MarqueeContainer = styled.div`
  width: 100%;
  height: 100%;
`
export const MarqueeText = styled.div`
  text-align: left;
  width: auto;
  white-space: nowrap;
  a {
    color: ${({ theme }) => theme.colors.accent};
  }
`
export const MarqueeElem = styled.div<{
  $width: number
  $offset: number
  $isActiveAnimation: boolean
  $animationDuration: number
  $delay: number
  $animationName: string
}>`
  display: flex;
  width: ${({ $width }) => ($width ? `${$width * 2}px` : '100%')};

  ${({ $isActiveAnimation, $animationDuration, $delay, $animationName }) =>
    $isActiveAnimation &&
    css`
      animation: ${$animationName} ${$animationDuration}s linear ${$delay}s
        infinite;
    `}

  ${MarqueeText} {
    padding-right: ${({ $offset }) => `${$offset}px`};
  }

  @keyframes marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  @keyframes marqueeWithDelay {
    0% {
      transform: translateX(0%);
    }
    85% {
      transform: translateX(-50%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`
